import { snakeCase, camelCase } from './strings';

const defaultConvertKeysOptions = {
  deep: false
};
export function convertKeys(obj, func, options = {}) {
  const opts = {
    ...defaultConvertKeysOptions,
    ...options
  };

  if (obj === undefined || obj === null) {
    return obj;
  }

  const result = obj.constructor();

  Object.keys(obj).forEach((keyName) => {
    const isObject = Object(obj[keyName]) === obj[keyName];
    const value =
      isObject && opts.deep
        ? convertKeys(obj[keyName], func, options)
        : obj[keyName];
    const convertedKeyName = func(keyName);

    result[convertedKeyName] = value;
  });

  return result;
}

export const snakeCaseKeys = (obj, opts = {}) =>
  convertKeys(obj, snakeCase, opts);

export const camelCaseKeys = (obj, opts = {}) =>
  convertKeys(obj, camelCase, opts);
